import React from 'react';

const Button_submit = ({ onClick, data, type,aditional }) => {
  return (
    <div className={`relative inline-block p-[4px] rounded-3xl bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-teal-500 via-blue-500 via-indigo-500 to-purple-500 animate-gradient-move ${aditional}`}>
      <button
        className="relative bg-white text-black px-6 py-2 flex rounded-3xl focus:outline-none font-bold text-xl"
        type={type}
        onClick={onClick}
      >
        {data}
      </button>
    </div>
  );
};

export default Button_submit;
